import { render, staticRenderFns } from "./GoodsSizeItems.vue?vue&type=template&id=3289c48e&scoped=true&"
import script from "./GoodsSizeItems.vue?vue&type=script&lang=js&"
export * from "./GoodsSizeItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3289c48e",
  null
  
)

export default component.exports